import { initializeApp, } from "firebase/app";
import { getAuth, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Platform } from "quasar";

const firebaseConfig = {
  apiKey: "AIzaSyAlS7P3SETQL4b9s645pjLRCuPx6T7l_nA",
  authDomain: "tokatab-app.firebaseapp.com",
  projectId: "tokatab-app",
  storageBucket: "tokatab-app.firebasestorage.app",
  messagingSenderId: "472792646988",
  appId: "1:472792646988:web:b21869003b496617e03be9",
  measurementId: "G-4SVN2VQY74"
};

const app = initializeApp(firebaseConfig);
export const auth = Platform.is.capacitor ? initializeAuth(app, {
  persistence: indexedDBLocalPersistence,
}) : getAuth(app)

export const firebaseAuthentication = FirebaseAuthentication